import React from 'react';
import PropTypes from 'prop-types';
import { SFEntityID, ProgressSurveyQuestion } from 'utils/types';
import css from './MainRow.scss';
import { Table } from 'semantic-ui-react';
import MobileQuestion from './MobileQuestion';

export default class MobileQuestionsRow extends React.Component {

  get class() {
    return `${css['expanded-row']} ${this.props.hasError ? css['error'] : ""} `;
  }

  render() {
    return (
      <Table.Row className={this.class}>
        <Table.Cell colSpan={2}>
          {this.props.availableQuestions.map(question => (
            <MobileQuestion
              key={question.id}
              question={question}
              checked={this.props.isChecked(question.id)}
              studentId={this.props.studentId}
              studentName={this.props.studentName}
              numberOfQuestions={this.props.availableQuestions.length}
              onAnswerChanged={this.props.onAnswerChanged}
              answers={this.props.answers}
              renderCheckbox={this.props.renderCheckbox}
            />
          ))}
        </Table.Cell>
      </Table.Row>
    )
  }
}

MobileQuestionsRow.propTypes = {
  renderCheckbox: PropTypes.func.isRequired,
  studentId: SFEntityID.isRequired,
  studentName: PropTypes.string.isRequired,
  availableQuestions: PropTypes.arrayOf(ProgressSurveyQuestion),
  isChecked: PropTypes.func.isRequired,
  onAnswerChanged: PropTypes.func.isRequired,
  answers: PropTypes.array,
  hasError: PropTypes.bool.isRequired
};
